<template>
  <div class="profil">

    <b-container>
      <b-row v-if="$auth.getRoles().indexOf('manager') > -1">
        <b-col cols="12">
          <PriceAnalytics v-if="clientMy.type === 'platform'"/>
          <PriceAnalyticsPlugin v-if="clientMy.type === 'plugin'"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card-group deck>
            <b-card
              v-if="$auth.getRoles().indexOf('manager') > -1"
              no-body
              border-variant="msstream"
              class="marginal"
            >
              <b-card-header
                header-bg-variant="msstream"
                header-text-variant="white"
                class="text-center"
              >
                <h5 class="m-0">
                  <font-awesome-icon icon="id-card-alt" />
                  &nbsp;{{$ml.get('clientinfo')}}
                </h5>
              </b-card-header>
              <b-card-body>
                <div v-if="!modified">
                  <b-table-simple stacked>
                    <b-tbody>
                      <b-tr>
                        <b-td :stacked-heading="$ml.get('clientnbr')">{{
                          clientMy.clientNumber
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('contractnbr')">{{
                          clientMy.contractNumber
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('companyname')">{{
                          clientMy.enterpriseName
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('siret')">{{
                          clientMy.SIRET
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('contactname')">{{
                          clientMy.contactName
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('contact1stname')">{{
                          clientMy.contactFirstName
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('email')">{{
                          clientMy.email
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('phone')">{{
                          clientMy.phone
                        }}</b-td>
                        <b-td :stacked-heading="$ml.get('postaladdr')">{{
                          clientMy.postalAddress
                        }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
                <div v-if="modified">
                  <b-form-group
                    id="name_enterprise"
                    :label="$ml.get('companyname')"
                    label-for="enterprise_Name"
                  >
                    <b-form-input
                      id="enterprise_Name"
                      v-model="clientMyTmp.enterpriseName"
                      required
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="siret" :label="$ml.get('siret')" label-for="siretid">
                    <b-form-input
                      id="siretid"
                      v-model="clientMyTmp.SIRET"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    id="contactName"
                    :label="$ml.get('contactname')"
                    label-for="contact_name"
                  >
                    <b-form-input
                      id="contact_name"
                      v-model="clientMyTmp.contactName"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    id="contactFirstName"
                    :label="$ml.get('contact1stname')"
                    label-for="contact_first_name"
                  >
                    <b-form-input
                      id="contact_first_name"
                      v-model="clientMyTmp.contactFirstName"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="email" :label="$ml.get('email')" label-for="emailid">
                    <b-form-input
                      id="emailid"
                      v-model="clientMyTmp.email"
                      type="email"
                      disabled
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="phone" :label="$ml.get('phone')" label-for="phoneid">
                    <b-form-input
                      id="phoneid"
                      v-model="clientMyTmp.phone"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="postalinput" :label="$ml.get('postaladdr')" label-for="postalid">
                    <b-form-input
                      id="postalid"
                      v-model="clientMyTmp.postalAddress"
                      type="text"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <b-row
                  class="justify-content-center"
                  v-if="!modified && $auth.getRoles().indexOf('manager') > -1"
                >
                  <b-button variant="mswarning " @click="editInfo"
                    ><font-awesome-icon icon="pencil-alt" />&nbsp;Edit</b-button
                  >
                </b-row>
                <b-row class="justify-content-around" v-if="modified">
                  <b-button
                    variant="msstreamblue"
                    @click="
                      editInfo();
                      putMyClient();
                    "
                    ><font-awesome-icon icon="check" />&nbsp;Update</b-button
                  >
                  <b-button
                    variant="quanteeclg"
                    @click="editInfo();cancelEditInfo()"
                    ><font-awesome-icon style="color:red" icon="times" />&nbsp;Cancel</b-button
                  >
                </b-row>
              </b-card-body>
            </b-card>

            <b-card no-body border-variant="msstream" class="marginal">
              <b-card-header
                header-bg-variant="msstream"
                header-text-variant="white"
                class="text-center"
              >
                <h5 class="m-0">
                  <font-awesome-icon icon="id-badge" />&nbsp;
                  {{$ml.get('accountinfo')}}
                </h5>
              </b-card-header>
              <b-card-body>
                <b-form @submit.prevent="">
                  <b-row class="justify-content-center">
                    <b-col class="col-md-12 col-sm-12">
                      <b-form-group :label="$ml.get('username')" label-for="login">
                        <b-form-input
                          disabled
                          v-model="account[0].login"
                          id="login"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group :label="$ml.get('email')" label-for="email">
                        <b-input-group>
                          <b-form-input
                            style="border-bottom-right-radius:0.25rem; border-top-right-radius:0.25rem"
                            :state="correctMail"
                            v-model="newMail"
                            id="email"
                          ></b-form-input>

                          <b-form-invalid-feedback>
                            {{$ml.get('invalidemail')}}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>

                          <b-form-group v-if="newMail != account[0].email">
                          <b-input-group>
                          <b-form-input
                            v-model="oldPasswordEmail"
                            :state="correctPassword"
                            :type="oldPasswordTypeEmail"
                            id="oldPasswordMail"
                            :placeholder="$ml.get('enterpass')"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              tabindex="-1"
                              v-if="oldPasswordTypeEmail === 'password'"
                              variant="db-sb1"
                              @click="oldPasswordTypeEmail = 'text'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye']"
                              ></font-awesome-icon
                            ></b-button>
                            <b-button
                              tabindex="-1"
                              v-if="oldPasswordTypeEmail === 'text'"
                              variant="db-sb1"
                              @click="oldPasswordTypeEmail = 'password'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye-slash']"
                              ></font-awesome-icon
                            ></b-button>
                          </b-input-group-append>
                          </b-input-group>
                          </b-form-group>


                      <b-row class="justify-content-around mb-4" v-if="newMail != account[0].email">
                        <b-button
                          variant="msstreamblue"
                          @click="putMyEmail()"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                          ></font-awesome-icon>
                          {{$ml.get('updateemail')}}
                        </b-button>
                        <b-button
                          variant="quanteeclg"
                          @click="newMail = account[0].email"
                        >
                          <font-awesome-icon style="color:red"
                            :icon="['fas', 'times']"
                          ></font-awesome-icon>
                          {{$ml.get('cancel')}}
                        </b-button>
                      </b-row>

                      <b-form-group
                        :label="$ml.get('newpass')"
                        label-for="passwordvalid"
                      >
                        <b-input-group style="margin-bottom:5px">
                          <b-form-input
                            v-model="newPassword"
                            :state="correctPassword"
                            :type="passwordType"
                            id="passwordvalid"
                            :placeholder="$ml.get('enternpass')"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              tabindex="-1"
                              v-if="passwordType === 'password'"
                              variant="db-sb1"
                              @click="passwordType = 'text'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye']"
                              ></font-awesome-icon
                            ></b-button>
                            <b-button
                              tabindex="-1"
                              v-if="passwordType === 'text'"
                              variant="db-sb1"
                              @click="passwordType = 'password'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye-slash']"
                              ></font-awesome-icon
                            ></b-button>
                          </b-input-group-append>

                          <b-form-invalid-feedback>
                            {{$ml.get('pass7')}}
                          </b-form-invalid-feedback>
                        </b-input-group>

                        <b-input-group>
                          <b-form-input
                            v-model="confirmPassword"
                            :type="ConfirmPasswordType"
                            id="passwordConfirm"
                            :placeholder="$ml.get('confirmpass')"
                            :state="indenticalPasswords"
                          ></b-form-input>

                          <b-input-group-append>
                            <b-button
                              tabindex="-1"
                              v-if="ConfirmPasswordType === 'password'"
                              variant="db-sb1"
                              @click="ConfirmPasswordType = 'text'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye']"
                              ></font-awesome-icon
                            ></b-button>
                            <b-button
                              tabindex="-1"
                              v-if="ConfirmPasswordType === 'text'"
                              variant="db-sb1"
                              @click="ConfirmPasswordType = 'password'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye-slash']"
                              ></font-awesome-icon
                            ></b-button>
                          </b-input-group-append>

                          <b-form-invalid-feedback>
                            {{$ml.get('passident')}}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>

                          <b-form-group  v-if="newPassword !== ''">
                          <b-input-group>
                          <b-form-input
                            v-model="oldPasswordPassword"
                            :state="correctPassword"
                            :type="oldPasswordTypePassword"
                            id="oldPasswordPassword"
                            :placeholder="$ml.get('enterold')"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              tabindex="-1"
                              v-if="oldPasswordTypePassword === 'password'"
                              variant="db-sb1"
                              @click="oldPasswordTypePassword = 'text'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye']"
                              ></font-awesome-icon
                            ></b-button>
                            <b-button
                              tabindex="-1"
                              v-if="oldPasswordTypePassword === 'text'"
                              variant="db-sb1"
                              @click="oldPasswordTypePassword = 'password'"
                              ><font-awesome-icon
                                :icon="['fas', 'eye-slash']"
                              ></font-awesome-icon
                            ></b-button>
                          </b-input-group-append>
                          </b-input-group>
                          </b-form-group>

                      <b-row class="justify-content-around mb-4" v-if="newPassword !== ''">
                        <b-button
                          variant="msstreamblue"
                          @click="
                            editPassword();
                            putMyPassword();
                          "
                        >
                          <font-awesome-icon
                            :icon="['fas', 'check']"
                          ></font-awesome-icon>
                          {{$ml.get('updatepass')}} 
                        </b-button>

                        <b-button
                          variant="quanteeclg"
                          @click="newPassword = ''; confirmPassword = ''"
                        >
                          <font-awesome-icon style="color:red"
                            :icon="['fas', 'times']"
                          ></font-awesome-icon>
                          {{$ml.get('cancel')}}
                        </b-button>
                      </b-row>
                      <small>
                        *{{$ml.get('pass7')}}
                      </small>

                      <b-row class="justify-content-center m-4">
                        <b-form-checkbox
                          v-model="isAlertMailFlux"
                          switch
                          @input="updateAlertMailFlux()"
                        />
                        
                        <font-awesome-layers
                        style="margin: 0px 10px 0px 5px"
                        v-if="isAlertMailFlux === true"
                        > 
                        <font-awesome-icon
                          style="color: #2a5d77"
                          :icon="['fas', 'envelope']"
                        />
                        <font-awesome-icon
                          style="color: #14bf98"
                          :icon="['fas', 'check-circle']"
                          transform="shrink-3 up-5 right-6"
                        />
                        </font-awesome-layers>

                        <font-awesome-layers style="margin: 0px 10px 0px 5px" v-else>
                          <font-awesome-icon
                            style="color: #2a5d77"
                            :icon="['fas', 'envelope']"
                          />
                          <font-awesome-icon
                            style="color: red"
                            :icon="['fas', 'minus-circle']"
                            transform="shrink-3 up-5 right-6"
                          />
                        </font-awesome-layers>
                          
                         {{
                          isAlertMailFlux
                            ? $ml.get('wishalert')
                            : $ml.get('wishnotalert')
                          }}
                      </b-row>

                      <b-row class="justify-content-center m-4">
                        <b-button
                          variant="msstreamblue"
                          @click="loadAPI()"
                        >
                          <font-awesome-icon icon="code"
                          ></font-awesome-icon>
                          {{$ml.get('apidoc')}}
                        </b-button>
                        </b-row>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>

      <b-card
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <b-row class="align-items-center justify-content-center">
            <font-awesome-icon icon="user-tie" />&nbsp;
              {{$ml.get('collab')}}
            &nbsp;<b-badge>{{users.length}}</b-badge>
            </b-row>
          </h5>
        </b-card-header>
        <b-card-body>
          <b-table
            show-empty
            centered
            responsive
            striped
            bordered
            :items="users"
            :fields="managerTable"
          >
            <template v-slot:cell(username)="row">
              <b-row class="justify-content-between align-items-center mr-2 ml-2  ">
              <div style="word-break:break-word; max-width:250px; margin:10px 0px">{{ row.item.username }}</div>
                <b-button
                  size="sm"
                  variant="darkblue"
                  v-if="row.item.username !== account[0].login"
                  @click="
                    userSelected = row.item.username;
                    OpenChatUser();
                  "
                >
                  <font-awesome-icon :icon="['fas', 'comments']" />
                  Chat
                </b-button>
              </b-row>
            </template>

            <template v-slot:cell(isManager)="row">
              <b-form-checkbox
                v-model="row.item._isManager"
                switch
                :disabled="(row.item.username === $auth.getMyUser().username) || ($auth.getRoles().indexOf('manager') === -1)"
                @input="updateUserRole(row.item)"
              >
                {{ row.item._isManager ? "Account manager" : "" }}
              </b-form-checkbox>
            </template>
            <template v-slot:cell(isEditor)="row">
              <b-form-checkbox
                v-model="row.item._isEditor"
                switch
                :disabled="(row.item._isManager) || ($auth.getRoles().indexOf('manager') === -1)"
                @input="updateUserRole(row.item)"
              >
                {{ row.item._isEditor ? "Videos manager" : "" }}
              </b-form-checkbox>
            </template>

            <template v-slot:cell(remove)="row">
              <b-button
                variant="quanteec"
                size="sm"
                @click="
                  userSelected = row.item.username;
                  showModal('confirmDelete');
                "
                v-if="row.item.username !== $auth.getMyUser().username"
                >
                  <font-awesome-icon icon="user-times" />
                  {{$ml.get('delete')}} 
              </b-button
              >
            </template>
          </b-table>
          <b-row v-if="$auth.getMyUser().roles.indexOf('manager') > -1" class="justify-content-center">
            <b-col style="padding: 0.2rem; text-align: center">
              <b-button 
                class="col-md-5 col-12"
                variant="msstreamblue" 
                style="padding:6px"
                v-b-modal.newUser
              >
                <font-awesome-icon icon="user-plus" />                
                {{$ml.get('createcollab')}}
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <VireedTeam v-if="type === 'platform'"> </VireedTeam>

      <Outro v-if="type === 'platform' && $auth.getRoles().indexOf('manager') > -1"></Outro>

      <Pictures v-if="type === 'platform' && $auth.getRoles().indexOf('manager') > -1"></Pictures>

      <ApiKeys v-if="type === 'plugin' && $auth.getRoles().indexOf('manager') > -1"></ApiKeys>

      <b-card
        v-if="$auth.getRoles().indexOf('manager') > -1 && clientViewObject.type === 'plugin'"
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <font-awesome-icon icon="cogs" />&nbsp;
            {{$ml.get('param')}}
          </h5>
        </b-card-header>
        <b-card-body>
          <h6 class="marginal text-center">{{$ml.get('titledp')}}</h6>

            <b-row>
              <b-col cols="auto" >
                <b-form-group style="margin-bottom:10px">
                  <b-form-checkbox size="sm" id="isAuth" disabled v-model="authorizedStream" @change="updateAuthorizedStreams()" switch >
                    &nbsp;
                    <span style="font-size:small">
                      <font-awesome-icon v-if="authorizedStream" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      <font-awesome-icon v-if="!authorizedStream" style="color: red" :icon="['fas', 'minus-circle']" />
                      {{
                        authorizedStream
                        ? $ml.get('pluginvideoisauthorized')
                        : $ml.get('pluginvideoisnotauthorized')
                      }}
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="align-items-center mb-3" v-if="isAuthorizedIPs === 'IPAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('pluginvideoauthip')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(authIP, authIPIdx) in authorizedIPs" v-bind:key="authIPIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{authIP}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="isAuthorizedIPs === 'IPNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
               {{$ml.get('pluginvideounauthip')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(notAuthIP, notAuthIPIdx) in unauthorizedIPs" v-bind:key="notAuthIPIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{notAuthIP}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3"  v-if="isAuthorizedCountries === 'countriesAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('pluginvideoauthcountry')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(authC, authCIdx) in authorizedCountries" v-bind:key="authCIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{authC}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="isAuthorizedCountries === 'countriesNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
               {{$ml.get('pluginvideounauthcountry')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(notAuthC, notAuthCIdx) in unauthorizedCountries" v-bind:key="notAuthCIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{notAuthC}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3"  v-if="isAuthorizedWebsites === 'websitesAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('cdnwhitelistedwebsites')}}:&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(whiteW, whiteWIdx) in whitelistedWebsite" v-bind:key="whiteWIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{whiteW}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3"  v-if="isAuthorizedWebsites === 'websitesNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                {{$ml.get('cdnblacklistedwebsites')}}:&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(blackW, blackWIdx) in blacklistedWebsite" v-bind:key="blackWIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{blackW}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="auto" >
                <b-form-group style="margin-bottom:0px">
                  <b-form-checkbox size="sm" disabled id="isVPN" v-model="authorizedVPNs" @change="updateAuthorizedVPNs()" switch >
                    &nbsp;
                    <span style="font-size:small">
                      <font-awesome-icon v-if="authorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      <font-awesome-icon v-if="!authorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
                      {{
                      authorizedVPNs
                        ? $ml.get('videopluginvpn')
                        : $ml.get('videopluginnotvpn')
                      }}
                      <span v-if="!authorizedVPNs && authorizedVPNsList.length === 0 ">
                         {{$ml.get('smallnone')}}
                      </span>
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <div v-if="!authorizedVPNs">
            <b-row v-for="(authVPN, authVPNIdx) in authorizedVPNsList" v-bind:key="authVPNIdx" class="justify-content-center m-1" >
              <span style="font-size:small">
                {{authVPN}}
              </span>
            </b-row>
            </div>

            <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

            <b-row class="mb-2 align-items-center">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon :icon="['fas', 'cogs']" />
                ICE config:
                <span v-if="ICEConfig === 'QUANTEEC'">
                  <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:15px" />
                  QUANTEEC
                </span>
                <span v-if="ICEConfig === 'local'">
                  Local network only
                </span>
                <span v-if="ICEConfig === 'custom'">
                  Custom ({{customIce.length}})
                </span>
              </b-col>
            </b-row>

            <span v-if="ICEConfig==='custom'">
              <b-row  v-for="(ice, indexIce) in customIce" v-bind:key="ice._id" class="mr-1 ml-1 mb-1" style="font-size:small">
                {{(ice.credential !== undefined ? 'TURN: ' : 'STUN: ')}}&nbsp; 
                <div v-for="(url, idx) in ice.urls" v-bind:key="idx">
                  {{ice.urls[idx]}} &nbsp;
                </div>
              </b-row>
            </span>

            <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

            <b-row class="align-items-center justify-content-around mb-3">
              <b-col cols="auto">
                <b-btn size="sm" variant="mswarning" @click="showModal('authorizations')" >Modify</b-btn>
              </b-col>
            </b-row>

            <h6 class="marginal text-center">Managed CDN with our partners</h6>
            <CustomCDN style="font-size: 12px;"></CustomCDN>



        </b-card-body>
      </b-card>

      <b-card
        v-if="$auth.getRoles().indexOf('manager') > -1"
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <font-awesome-icon icon="file-alt" />&nbsp;
            {{$ml.get('docs')}}
          </h5>
        </b-card-header>
        <b-card-body>
          <h5 class="marginal">{{$ml.get('bills')}}</h5>
          <div v-for="yearsBills in billYears" v-bind:key="yearsBills">
            <b-row>
              <b-col cols="12">
                <h5 @click="focusBill(yearsBills)" style="cursor: pointer">
                  <font-awesome-icon
                    v-if="focusYearBill !== yearsBills"
                    :icon="['fas', 'caret-right']"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="focusYearBill === yearsBills"
                    :icon="['fas', 'caret-down']"
                  ></font-awesome-icon>
                  {{ yearsBills }}
                </h5>
              </b-col>
            </b-row>
            <b-row v-if="focusYearBill === yearsBills">
              <b-col
                md="2"
                cols="4"
                v-for="bill in bills[yearsBills]"
                v-bind:key="bill.uuid"
              >
                <b-row class="justify-content-center">
                  <b-col lg="6" cols="12">
                    <b-img
                      :src="require('@/assets/pdf.png')"
                      style="cursor: pointer"
                      fluid
                      @click="downloadDocuments(bill.filename)"
                    ></b-img>
                  </b-col>
                </b-row>
                <b-row lg="6" class="justify-content-center">
                  <b-col cols="12" style="text-align: center">
                    <h6
                      style="cursor: pointer"
                      @click="downloadDocuments(bill.filename)"
                    >
                      {{ bill._month }}
                    </h6>
                    <!--<font-awesome-icon  style="cursor:pointer;" v-if="$auth.getMyUser().roles.indexOf('admin') > -1" :icon="['fas', 'trash-alt']" @click.prevent="deleteDocument(obj)"></font-awesome-icon>-->
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr />
          </div>

          <br />
          <h5>{{$ml.get('odocs')}}</h5>

          <b-row>
            <b-col
              md="2"
              cols="4"
              v-for="contract in contracts"
              v-bind:key="contract.uuid"
            >
              <b-row class="justify-content-center">
                <b-col lg="6" cols="12">
                  <b-img
                    :src="require('@/assets/pdf.png')"
                    style="cursor: pointer"
                    fluid
                    @click="downloadDocuments(contract.filename)"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row lg="6" class="justify-content-center">
                <b-col cols="12" style="text-align: center">
                  <h6
                    style="cursor: pointer"
                    @click="downloadDocuments(contract.filename)"
                  >
                    {{ contract.filename }}
                  </h6>
                  <!--<font-awesome-icon  style="cursor:pointer;" v-if="$auth.getMyUser().roles.indexOf('admin') > -1" :icon="['fas', 'trash-alt']" @click.prevent="deleteDocument(obj)"></font-awesome-icon>-->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        v-if="$auth.getRoles().indexOf('manager') > -1"
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <font-awesome-icon style="color:red" :icon="['fas', 'id-card-alt']" />
            &nbsp;{{$ml.get('unsub')}}
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row class="justify-content-center">
            <b-button
              v-if="!clientMy.dataToDelete"
              variant="quanteec"
              @click="showModal('confirmDeleteAccount')"
            >
              <font-awesome-icon :icon="['fas', 'trash']" />&nbsp;
              {{$ml.get('deleteclient')}}</b-button
            >
          </b-row>
          <b-row class="justify-content-center" style="margin:10px" v-if="clientMy.dataToDelete">
              {{$ml.get('deleteclienttxt')}}
          </b-row>
          <b-row class="justify-content-center">          
            <b-button
              v-if="clientMy.dataToDelete"
              variant="green"
              @click="showModal('cancelDeletion')"
            >
              <font-awesome-icon :icon="['fas', 'redo-alt']" />&nbsp;              
              {{$ml.get('canceldel')}}</b-button
            >
          </b-row>
        </b-card-body>
      </b-card>
      <br />
      <br />
      <br />
    </b-container>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('collabdel')}}
        </h4>
      </div>
      <p style="line-height:normal">{{$ml.get('confirmcollabdel')}} <strong><span style="color: #2F90B0; word-break:break-word">{{userSelected}}</span></strong>.<br> {{$ml.get('makesure')}} <br>{{$ml.get('norecover')}} </p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteec" @click="removeUser(userSelected);hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmDelete')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDeleteAccount" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'id-card-alt']" />
          {{$ml.get('claccdel')}}
        </h4>
      </div>
      <p style="line-height:normal" v-html="$ml.get('claccdelconfirm')">
      </p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteec" @click="deleteAccount();hideModal('confirmDeleteAccount')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmDeleteAccount')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="successPassword" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:#14BF98" icon="key" />
          {{$ml.get('passwdmodif')}}
        </h4>
      </div>
      <p style="line-height:normal">{{$ml.get('passwdmodiftxt')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('successPassword')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorPassword" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="key" />
          {{$ml.get('errpassmod')}}
        </h4>
      </div>
      <p style="line-height:normal">
        {{$ml.get('errpassmodtxt')}}
      </p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorPassword')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorOldPassword" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" icon="key" />
          {{$ml.get('erroldpass')}}
        </h4>
      </div>
      <p style="line-height:normal">
        {{$ml.get('erroldpasstxt')}}
      </p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorOldPassword')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="cancelDeletion" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:#14BF98" :icon="['fas', 'id-card-alt']" />
          {{$ml.get('keepclacc')}}
        </h4>
      </div>
      <p style="line-height:normal">{{$ml.get('keepclacctxt')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="green" @click="cancelDeletionAccount(); hideModal('cancelDeletion')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'redo-alt']" />
          {{$ml.get('keepclacc')}}
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('cancelDeletion')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal 
      hide-footer 
      id="newUser"
      :title="$ml.get('newcollab')"
    >
      <UserForm v-on:userCreated="userCreated()" v-on:closeUserCreated="closeModalUserCreated()"></UserForm>
    </b-modal>

    <b-modal ref="errorMailUsed" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'envelope-open']" />
          {{$ml.get('erremail')}}
        </h4>
      </div>
      <p style="line-height:normal">{{$ml.get('erremailtxt')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorMailUsed')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'envelope-open']" />
          {{$ml.get('erremail')}}
        </h4>
      </div>
      <p style="line-height:normal">{{$ml.get('erremailtxt2')}}</p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorMail')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="validationMail" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px; color:#14BF98" :icon="['fas', 'envelope-open']" />
          {{$ml.get('verifemail')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('verifemailtxt')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('validationMail');refreshLoginAfterChangingMail()">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

  <b-modal 
    id="authorizations"
    ref="authorizations"
    title="Videos default configuration"
    @show="openModalAuthorization"
    no-close-on-backdrop
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">

     <b-card-body>

      <b-row class="justify-content-center mb-3">
        <h6>
          {{$ml.get('pluginvideoauthorizations')}}
        </h6>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" v-model="authorizedStreamTmp" switch >
          &nbsp;
          <font-awesome-icon v-if="authorizedStreamTmp" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!authorizedStreamTmp" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            authorizedStream
            ? $ml.get('pluginvideoisauthorized')
            : $ml.get('pluginvideoisnotauthorized')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row class="justify-content-center mb-1" style="font-size:10px">
        <p v-if="authorizedStreamTmp">{{$ml.get('pluginvideostreamed')}}</p>
        <p v-if="!authorizedStreamTmp">{{$ml.get('pluginvideonotstreamed')}}</p>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedIPsTmp" name="some-radiosIP" value="IPAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthip2')}}
          </b-form-radio>        
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedIPsTmp" name="some-radiosIP" value="IPNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthip2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop5')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop6')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaIP" :disabled="isAuthorizedIPsTmp === 'IPNotAuthorized'" style="font-size:small"
          v-model="authorizedIPsTagsTmp" placeholder="IP address + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuIP" :disabled="isAuthorizedIPsTmp === 'IPAuthorized'" style="font-size:small"
          v-model="unauthorizedIPsTagsTmp" placeholder="IP address + Enter"></tags-input>
      </b-row>


      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedCountriesTmp" name="some-radiosC" value="countriesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthcountry2')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedCountriesTmp" name="some-radiosC" value="countriesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthcountry2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop7')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop8')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaC" :disabled="isAuthorizedCountriesTmp === 'countriesNotAuthorized'" style="font-size:small"
          v-model="authorizedCountriesTagsTmp" placeholder="Country + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="taguCs" :disabled="isAuthorizedCountriesTmp === 'countriesAuthorized'" style="font-size:small"
          v-model="unauthorizedCountriesTagsTmp" placeholder="Country + Enter"></tags-input>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedWebsitesTmp" name="some-radiosW" value="websitesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideowhitewb')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedWebsitesTmp" ame="some-radiosW" value="websitesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideoblackwb')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop9')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop10')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaW" :disabled="isAuthorizedWebsitesTmp === 'websitesNotAuthorized'" style="font-size:small"
          v-model="whitelistedWebsiteTagsTmp" placeholder="Website + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuW" :disabled="isAuthorizedWebsitesTmp === 'websitesAuthorized'" style="font-size:small"
          v-model="blacklistedWebsiteTagsTmp" placeholder="Website + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" id="isStreamingModal" v-model="authorizedVPNsTmp" switch >
          &nbsp;
          <font-awesome-icon v-if="authorizedVPNsTmp" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!authorizedVPNsTmp" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            authorizedVPNs
            ? $ml.get('pluginvideoisvpn')
            : $ml.get('pluginvideoisnotvpn')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row v-if="!authorizedVPNsTmp" class="justify-content-center mb-4">
        <tags-input element-id="tags" style="font-size:small"
          v-model="authorizedVPNsTagsTmp" placeholder="IP address + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:2rem 5rem"></b-row>

      <b-row class="justify-content-center mb-2">
        <h6>
          <font-awesome-icon :icon="['fas', 'cogs']" />&nbsp; {{$ml.get('pluginvideoiceconf')}}
        </h6>
      </b-row>
      <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
        <b-form-group>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfigTmp"  name="some-radios" value="QUANTEEC"></b-form-radio>
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:15px" />
            &nbsp;{{$ml.get('pluginvideodefault')}}
          </b-row>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfigTmp" name="some-radios" value="local"></b-form-radio>
            {{$ml.get('pluginvideolocalnet')}}
          </b-row>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfigTmp" name="some-radios" value="custom"></b-form-radio>
            {{$ml.get('pluginvideoicecustom')}}
          </b-row>
        </b-form-group>
      </b-row>

      <div v-if="ICEConfigTmp === 'custom'">

<!--
        <tags-input element-id="tagsSTUN" style="font-size:small"
          v-model="ice.urls" placeholder="STUN @ + Enter"></tags-input>

        <tags-input element-id="tagsTURN" style="font-size:small"
          v-model="ice.urls" placeholder="TURN @ + Enter"></tags-input>
-->

            <b-row class="align-items-center justify-content-around m-2" style="font-size:small"> 
              <b-btn size="sm" variant="msstreamblue" @click="addSTUN">{{$ml.get('pluginvideoaddstun')}}</b-btn>
              <b-btn size="sm" variant="msstreamblue" @click="addTURN">{{$ml.get('pluginvideoaddturn')}}</b-btn>
            </b-row>

          <div v-for="(ice, indexIce) in customIceTmp" style="margin:0.5rem 0rem; padding:0.25rem; padding-bottom:0.5rem; border: 1px solid #2a5d77; border-radius:0.25rem" v-bind:key="ice._id">
              <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
                {{(ice.credential !== undefined ? 'TURN' : 'STUN')}}&nbsp; 
                <b-button size="sm" variant="emptyB" @click="removeICE(indexIce)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
              </b-row>
              <b-row v-for="(url, idx) in ice.urls" v-bind:key="idx" class="align-items-center ml-1">
                <b-form-group 
                style="margin:2px 0px"
                label-cols-sm="3"
                content-cols-sm
                label-size="sm" 
                :label="'URL ' + Math.round(idx + 1) + ':'" 
                :label-for="'iceUrl' + ice._id + idx">
                  <b-form-input size="sm" v-model="ice.urls[idx]" :id="'iceUrl' + ice._id + idx"></b-form-input>
                </b-form-group>
                <b-button variant="emptyB" v-if="ice.urls.length > 1" size="sm" @click="removeUrl(ice, idx)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
                <b-button style="text-align:center" v-if="idx === ice.urls.length - 1" size="sm" variant="emptyB" @click="addUrl(ice)"><font-awesome-icon style="color:#2a5d77" :icon="['fas', 'plus']"></font-awesome-icon></b-button>
              </b-row>

            <b-row class="align-items-center ml-1">
              <b-form-group 
                  style="margin:2px 0px"
                  class="justify-content-center"
                  label-cols-sm="4"
                  label-size="sm" 
                  v-if="ice.username !== undefined" 
                  label="Username:" 
                  label-for="iceUsername">
                <b-form-input size="sm" v-model="ice.username" id="iceUsername"></b-form-input>
              </b-form-group>
            </b-row>
            <b-row class="align-items-center ml-1">
            <b-form-group 
                  style="margin:2px 0px"
                  label-cols-sm="4"
                  label-size="sm"             
                  v-if="ice.credential !== undefined" 
                  label="Password:" 
                  label-for="iceCredential">              
              <b-input-group>
                <b-form-input size="sm" :type="ice._showCredential" v-model="ice.credential" id="iceCredential"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="ice._showCredential === 'password'" variant="emptyB" @click="ice._showCredential = 'text'"><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon></b-button>
                    <b-button v-if="ice._showCredential === 'text'" variant="emptyB" @click="ice._showCredential = 'password'"><font-awesome-icon :icon="['fas', 'eye-slash']"></font-awesome-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-row>
          </div>
      </div>      

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

      <b-row class="justify-content-around mt-1">
        <b-button size="sm" @click="updateAuthorization(); hideModal('authorizations')" variant="mswarning">
          <font-awesome-icon icon="check" />
          {{$ml.get('pluginvideovalidate')}}
        </b-button>
        <b-button size="sm" @click="resetModalAuthorization(); hideModal('authorizations')" variant="quanteeclg">
          <font-awesome-icon style="color:red" icon="times" />
          {{$ml.get('cancel')}}
        </b-button>
      </b-row>
    </b-card-body>
   </b-card>
  </b-modal>


  </div>
</template>

<script>
import { BASE_URL } from "@/services/base-url";
import PriceAnalytics from "@/components/analytics/PriceAnalytics.vue";
import PriceAnalyticsPlugin from "@/components/analytics/PriceAnalyticsPlugin.vue";
import { saveAs } from "file-saver";
import UserService from "@/services/user.service";
import ClientService from "@/services/client.service";
import DocumentService from "@/services/document.service";
import { EventBus } from "@/event-bus.js";
import UserForm from "@/components/UserForm.vue";
import VireedTeam from "@/components/VireedTeam.vue";
import Pictures from "@/components/Pictures.vue";
import Outro from "@/components/Outro.vue";
import PluginParamsService from "@/services/videoPluginParams.service.js"
import {v4 as uuidv4} from 'uuid';
import CustomCDN from "@/components/CustomCDN.vue";
import ApiKeys from "@/components/ApiKeys.vue"
var userService = new UserService();
var clientService = new ClientService();
var documentService = new DocumentService();
var pluginParamsService = new PluginParamsService();
export default {
  name: "ProfilPage",
  components: {
    PriceAnalytics,
    PriceAnalyticsPlugin,
    UserForm,
    VireedTeam,
    CustomCDN,
    Pictures,
    ApiKeys,
    Outro
  },
  data: function () {
    return {

      authorizedStream:true,
      authorizedVPNs:true,
      authorizedIPs : [],
      unauthorizedIPs : [],
      authorizedCountries : [],
      unauthorizedCountries : [],
      whitelistedWebsite : [],
      blacklistedWebsite : [],
      authorizedVPNsList : [],
      authorizedIPsTags : [],
      unauthorizedIPsTags : [],
      authorizedCountriesTags : [],
      unauthorizedCountriesTags : [],
      whitelistedWebsiteTags : [],
      blacklistedWebsiteTagsTmp : [],
      authorizedVPNsTags : [],
      isAuthorizedIPs:"IPAuthorized",
      isAuthorizedCountries:"countriesAuthorized",
      isAuthorizedWebsites:"websitesAuthorized",
      ICEConfig : "QUANTEEC",
      customIce: [],

      authorizedStreamTmp:true,
      authorizedVPNsTmp:true,
      _authorizedIPs : [],
      _unauthorizedIPs : [],
      _authorizedCountries : [],
      _unauthorizedCountries : [],
      _whitelistedWebsite : [],
      _blacklistedWebsite : [],
      _authorizedVPNsList : [],
      authorizedIPsTagsTmp : [],
      unauthorizedIPsTagsTmp : [],
      authorizedCountriesTagsTmp: [],
      unauthorizedCountriesTagsTmp : [],
      whitelistedWebsiteTagsTmp : [],
      blacklistedWebsiteTagsTmp : [],
      authorizedVPNsTagsTmp : [],
      ICEConfigTmp : "QUANTEEC",
      customIceTmp: [],
      isAuthorizedIPsTmp:"IPAuthorized",
      isAuthorizedCountriesTmp:"countriesAuthorized",
      isAuthorizedWebsitesTmp:"websitesAuthorized",
      noDefaultParameters : false,

      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      clientViewObject: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientViewObject() || this.$auth.getMyUser().client_infos[0]
          : this.$auth.getMyUser().client_infos[0],
      typeFile: "bills",
      userFile: null,
      userSelected: null,
      users: [],
      clients: [],
      passwordType: "password",
      ConfirmPasswordType: "password",
      isAlertMailFlux:(this.$auth.getMyUser().isAlertMailFlux) ? true : false,
      managerTable: [
        { key: "username", label: "Username", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "email", label: "Email", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "isManager", label: "Account Manager", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "isEditor", label: "Videos Manager", thClass: 'text-center', tdClass: 'align-middle' },
        { key: "remove", label: "", thClass: 'text-center', tdClass: 'align-middle' },
      ],
      defaultForm: {
        defaultAudio: true,
        defaultMaxNumberOfQualities: 3,
        defaultEncoding: true,
        defaultEncodingLevel: 2,
        defaultEncodingSource: true,
      },
      optionsType: [
        { value: "bills", text: "Bill" },
        { value: "contracts", text: "Contract" },
      ],
      optionsUser: [],
      optionsClient: [],
      optionsAudio: [
        { value: true, text: "True, the majority of my videos have audio" },
        {
          value: false,
          text: "False, none or only a few of my videos have audio",
        },
      ],
      optionsMaxNumberOfQualities: [
        { value: 2, text: "2" },
        { value: 3, text: "3 - Default value" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
      ],
      optionsEncoding: [
        {
          value: true,
          text: "Encoding, the majority of my videos should be encoded in multiple qualities",
        },
        {
          value: false,
          text: "Passthrough, none or only a few of my videos should be encoded in multiple qualities",
        },
      ],
      optionsEncodingLevel: [
        {
          value: 1,
          text: "Fast encoding / Low quality - good for a high number of live streams",
        },
        { value: 2, text: "Intermediate - Default value" },
        {
          value: 3,
          text: "Slow encoding / Good quality - good for high quality VoD",
        },
      ],
      optionsEncodingSource: [
        {
          value: true,
          text: "Use source video as the best quality - Improve the quality but reduce the efficiency of the player",
        },
        {
          value: false,
          text: "Encode all of the qualities - The best quality is defined by the encoding level but improve the efficiency of the player",
        },
      ],

      // handle scroll
      ScrollDown: false,
      ScrollUp: false,
      ScrollDown2: false,
      ScrollUp2: false,

      //Table with client information. Actually it is enter in the code. We need to ask information to the API
      clientMy: {},

      // Login and password. Need API real information
      newMail: "",
      checkPasswordValidity: "",
      modified: false,
      modifyPass: false,
      account: [{ login: "", password: "" }],
      newPassword: "",
      confirmPassword: "",
      indenticalPasswords: undefined,
      correctPassword: undefined,
      correctMail: undefined,
      oldPasswordTypeEmail:"password",
      oldPasswordEmail:"",
      oldPasswordPassword:"",
      oldPasswordTypePassword:"password",

      //document (need to put real one and to create a module to download them)
      bills: {},
      billYears: [],
      isFirstBill: true,
      contracts: {},
      contractYears: [],
      focusYearBill: "",
      focusYearContract: "",

      file: null,
      clientMyTmp:{},

      type:"plugin"
    };
  },
  mounted() {
    this.initTable();
    try {
      //this.managescroll()
      //this.managescroll2()
      this.type = this.clientViewObject.type
      this.getBills();
      this.getContracts();
      this.getDefaultParameters();
    } catch (err) {}

    this.initMyUser();
    /*if (this.clientViewObject.vireed) {
        this.managerTable.splice(this.managerTable.length - 1, 0, { key: "isVireed", label: "Vireed privileges"});
    }*/
  },
  computed: {
    getItems() {
      return this.items;
    },
  },
  methods: {
    getDefaultParameters()
    {
      pluginParamsService.getDefaultParametersForClient(this.$auth.token())
      .then(params=>{
        console.log(params)
        this.authorizedIPs = params.authorizedIPs || [];
        this.unauthorizedIPs = params.unauthorizedIPs || [];
        this.authorizedCountries = params.authorizedCountries || [];
        this.unauthorizedCountries = params.unauthorizedCountries || [];
        this.whitelistedWebsite = params.whitelistedWebsite || [];
        this.blacklistedWebsite = params.blacklistedWebsite || [];

        if(params.authorizedStream === undefined || params.authorizedStream === null)
           this.authorizedStream = true;
        else
          this.authorizedStream = params.authorizedStream

        if(params.authorizedVPNs === undefined || params.authorizedVPNs === null)
          this.authorizedVPNs = true;
        else
          this.authorizedVPNs = params.authorizedVPNs

        this.authorizedVPNsList = params.authorizedVPNsList || [];

        this.ICEConfig = params.ICEConfig || "QUANTEEC"
        this.customIce = JSON.parse(JSON.stringify(params.customIce));

        this.isAuthorizedIPs = params.isAuthorizedIPs || "IPsAuthorized"
        this.isAuthorizedCountries = params.isAuthorizedCountries || "countriesAuthorized"
        this.isAuthorizedWebsites = params.isAuthorizedWebsites || "websitesAuthorized"
           

      }).catch(err=>{
        console.log(err)
      })
    },
    updateAlertMailFlux(){
      userService
          .putUser(
            this.$auth.getMyUser().username,
            {
              isAlertMailFlux:this.isAlertMailFlux
            },
            this.$auth.token()
            ).then(resqponse => {
              this.$auth.setMyUser({...this.$auth.getMyUser(), isAlertMailFlux:this.isAlertMailFlux})
            }).catch(err=>{
              console.log(err)
            })
    },
    deleteAccount() {
      clientService
        .deleteClientData(this.clientView, this.$auth.token())
        .then(() => {
          this.$auth.logout();
          this.$router.push("/auth");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelDeletionAccount() {
      clientService
        .cancelDeletionClientData(this.clientView, this.$auth.token())
        .then(() => {
          this.clientMy.dataToDelete = false;
          this.$router.go();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    focusBill(yearsBills) {
      if (this.focusYearBill === yearsBills) {
        this.focusYearBill = "";
      } else {
        this.focusYearBill = yearsBills;
      }
    },
    postDocument() {
      var formData = new FormData();
      formData.append("client", this.userFile);
      formData.append("type", this.typeFile);
      formData.append("file", this.file, this.file.name);

      documentService.postDocument(this.$auth.token(), formData).then(() => {
        this.file = null;
        this.getBills();
        this.getContracts();
      });
    },
    loadAPI() {
      if(this.type === "platform")
      {
        window.open(BASE_URL + "/api/docs/", '_blank').focus();
      } else
      {
        window.open(BASE_URL + "/api/docsPlugin/", '_blank').focus();
      }
    },
    deleteDocument(documentID) {
      documentService.postDocument(this.$auth.token(), documentID).then(() => {
        this.file = null;
        this.getBills();
        this.getContracts();
      });
    },
    getBills() {
      if (this.$auth.getMyUser().roles.indexOf("manager") > -1) {
        let strUcFirst = function (a) {
          return (a + "").charAt(0).toUpperCase() + a.substr(1);
        };
        let months = [
          "december",
          "décembre",
          "november",
          "novembre",
          "october",
          "octobre",
          "september",
          "septembre",
          "august",
          "août",
          "july",
          "juillet",
          "june",
          "juin",
          "may",
          "mai",
          "april",
          "avril",
          "march",
          "mars",
          "february",
          "février",
          "january",
          "janvier",
        ];
        var client = this.clientView;
        documentService
          .getDocuments(this.$auth.token(), {
            filter: JSON.stringify({ type: "bills", client: client }),
            sort: { filename: -1 },
          })
          .then((documents) => {
            let billsPerYear = {};
            this.bills = [];
            for (let i = 0; i < documents._embedded.length; i++) {
              let bill = documents._embedded[i];
              bill._month = strUcFirst(bill.month);
              billsPerYear[bill.year] = billsPerYear[bill.year] || [];
              billsPerYear[bill.year].push(bill);
            }
            this.billYears = Object.keys(billsPerYear);
            this.billYears.sort((a, b) => +b - +a);
            for (let i = 0; i < this.billYears.length; i++) {
              billsPerYear[this.billYears[i]].sort((a, b) => {
                return (
                  months.indexOf(a.month.split(" ")[0]) -
                  months.indexOf(b.month.split(" ")[0])
                );
              });
            }
            if (this.billYears.length > 0 && this.isFirstBill) {
              this.focusYearBill = this.billYears[0];
            }
            this.isFirstBill = false;
            this.bills = billsPerYear;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getContracts() {
      if (this.$auth.getMyUser().roles.indexOf("manager") > -1) {
        var client = this.clientView;
        documentService
          .getDocuments(this.$auth.token(), {
            filter: JSON.stringify({ type: "contracts", client: client }),
          })
          .then((documents) => {
            this.contracts = documents._embedded;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    downloadDocuments(filename) {
      documentService
        .downloadDocuments(this.$auth.token(), filename)
        .then((data) => {
          saveAs(data, filename);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteDocument(filename) {
      documentService
        .deleteDocument(this.$auth.token(), filename)
        .then((data) => {
          this.getBills();
          this.getContracts();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initMyUser() {
      var user = this.$auth.getMyUser();
      var tableDefault = { ...this.clientMy };
      var accountDefault = this.account.pop();
      this.account.push({
        ...accountDefault,
        login: user.username,
        email: user.email,
      });
      this.newMail = user.email;
      this.clientMy = { ...tableDefault, ...this.clientViewObject };
      this.clientMyTmp = {...tableDefault, ...this.clientViewObject };
      this.getMyUser();
      this.getAllUsers();
      if (user.roles.indexOf("manager") === -1) {
        let toRemoves = ['isManager', 'isEditor', 'remove']
        toRemoves.forEach(toRemove => {
          let index = this.managerTable.findIndex( x => x.key === toRemove);
          if (index !== -1) {
            this.managerTable.splice(index, 1);
          }
        })
      }
      if (user.roles.indexOf("admin") > -1) {
        this.getAllClients();
      }
    },
    selectView() {
      this.$auth.setMyClientView(this.clientView);
      EventBus.$emit("ViewChanged", this.clientView);
      this.getBills();
      this.getContracts();
    },
    getAllClients() {
      userService.getClients(this.$auth.token()).then((data) => {
        var clients = data;
        this.clients = clients;
        this.optionsClient = clients.map((elem) => elem.clientname).sort();
      });
    },
    getAllUsers() {
      userService.getUsers(this.$auth.token()).then((data) => {
        var users = data;
        this.users = users;
        this.users.forEach(function (elem) {
          if (elem.roles) {
            if (elem.roles.indexOf("editor") > -1) {
              elem._isEditor = true;
            } else {
              elem._isEditor = false;
            }
            if (elem.roles.indexOf("manager") > -1) {
              elem._isManager = true;
              elem._isEditor = true;
            } else {
              elem._isManager = false;
            }
          }
        });
        this.optionsUser = users.map((elem) => elem.username).sort();
      });
    },
    getMyUser() {
      if (this.$auth.getMyUser().roles.indexOf("admin") === -1) {
        userService
          .getMyUser(this.$auth.token())
          .then((user) => {
            this.$auth.setMyUser(user);
            var tableDefault = { ...this.clientMy };
            var accountDefault = this.account.pop();
            this.account.push({ ...accountDefault, login: user.username });
            this.clientMy = { ...tableDefault, ...user.client_infos[0] };
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        userService
          .getUser(this.$auth.token(), this.clientView)
          .then((user) => {
            clientService.getClient(this.clientView, this.$auth.token()).then(client => {
              this.clientMy = { ...tableDefault, ...client };
              this.$auth.loadClientViewObject().catch(err=> {})
            }).catch(err => {})
            this.$auth.setMyClientView(user.client);
            var tableDefault = { ...this.clientMy };
            var accountDefault = this.account.pop();
            this.account.push({ ...accountDefault, login: user.username, email: user.email })
            this.newMail = user.email;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    updateUserRole(user) {
      var userData = {
        roles: [],
      };
      if (user._isManager) {
        userData.roles.push("manager");
        userData.roles.push("editor");
      }
      if (user._isEditor) {
        userData.roles.push("editor");
      }
      userService
        .putUser(user.username, userData, this.$auth.token())
        .then((user) => {
          this.getAllUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    putMyClient() {
      this.clientMy = JSON.parse(JSON.stringify(this.clientMyTmp));
      var tableDefault = { ...this.clientMy };
      delete this.clientMy.contractNumber;
      delete this.clientMy.clientNumber;

      clientService
        .putMyClient(
          this.clientView,
          this.clientMy,
          this.$auth.token()
        )
        .then((client) => {
          this.getMyUser();
          this.clientMy = { ...tableDefault, ...client };
        })
        .catch((err) => {
          this.clientMy = { ...tableDefault };
          console.log(err);
        });
    },
    putMyPassword() {
      if (this.newPassword != this.confirmPassword) {
        this.indenticalPasswords = false;
        return;
      } else {
        this.indenticalPasswords = "";
      }

      let count = 0;
      if (this.newPassword.length >= 7) {
        if (this.newPassword.match(/.*[0-9].*/)) count++;

        if (this.newPassword.match(/.*[a-z].*/)) count++;

        if (this.newPassword.match(/.*[A-Z].*/)) count++;

        if (this.newPassword.match(/.*[!@#\$%\^\&*\)\(+=._-].*/)) count++;
      }

      if (count === 4) {
        this.correctPassword = true;
        this.indenticalPasswords = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            { password: this.newPassword,oldPassword:this.oldPasswordPassword },
            this.$auth.token()
          )
          .then((user) => {
            this.$auth.setUsernamePassword(
              this.$auth.getMyUser().username,
              this.newPassword
            );
            this.newPassword = "";
            this.confirmPassword = "";
            this.correctPassword = undefined;
            this.indenticalPasswords = undefined;
            this.oldPasswordPassword = ""
            EventBus.$emit("AuthChanged");
            this.showModal("successPassword");
          })
          .catch((err) => {
            if(err.response.status === 401) this.showModal("errorOldPassword")
            else 
            {this.showModal("errorPassword");}
            console.log(err);
          });
      } else {
        this.correctPassword = false;
      }
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    putMyEmail() {
      if (this.validateEmail(this.newMail)) {
        this.correctMail = true;
        userService
          .putUser(
            this.$auth.getMyUser().username,
            {
              newEmail: this.newMail,
              emailVerified: false,
              oldPassword:this.oldPasswordEmail,
              keyMail: [...Array(64)]
                .map((i) => (~~(Math.random() * 36)).toString(36))
                .join(""),
                timestamp:new Date(),
            },
            this.$auth.token()
          )
          .then((user) => {
            this.showModal("validationMail");
            this.account[0].email = this.newMail;
            this.oldPasswordEmail =""
          })
          .catch((err) => {
            console.log(err)
            if (err.response.status === 409) this.showModal("errorMailUsed");
            else if(err.response.status === 401) this.showModal("errorOldPassword")
            else {
              this.showModal("errorMail");
            }
            console.log(err.response.status);
          });
      } else {
        this.correctMail = false;
      }
    },
    refreshLoginAfterChangingMail()
    {
      console.log("here")
                  this.$auth
              .validateWithServer()
              .then(() => {
                EventBus.$emit("AuthChanged");
              })
              .catch((err) => {
                EventBus.$emit("AuthChanged");
                if (window.location.href.indexOf("/#/auth") === -1) {
                  this.$router.push("/auth");
                }
              });
    },
    removeUser(username) {
      userService
        .deleteUserById(username, this.$auth.token())
        .then((client) => {
          this.getAllUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    userCreated() {
      //TO-DO Fermer la modale de création et recharger la liste des utilisateurs.
      this.getAllUsers();
    },
    closeModalUserCreated() {
      this.$bvModal.hide("newUser");
    },
    initTable() {
      // Connect with API

      this.clientMy = {
        clientNumber: "",
        contractNumber: "",
        enterpriseName: "",
        SIRET: "",
        contactName: "",
        contactFirstName: "",
        email: "",
        phone: "",
      };

      this.account = [
        {
          username: "",
          password: "default password",
        },
      ];
    },
    editInfo() {
      if (this.modified == true) {
        this.modified = false;
      } else {
        this.modified = true;
      }
    },
    cancelEditInfo()
    {
      this.clientMyTmp = JSON.parse(JSON.stringify(this.clientMy));
    },
    editPassword() {
      if (this.modifyPass == true) {
        this.modifyPass = false;
      } else {
        this.modifyPass = true;
      }
    },
    managescroll2() {
      let div = document.querySelector(".onscroll2");
      if (
        div.scrollHeight - div.scrollTop !== div.clientHeight &&
        div.scrollTop !== 0
      ) {
        this.ScrollDown2 = true;
        this.ScrollUp2 = true;
      } else if (
        div.scrollHeight - div.scrollTop !== div.clientHeight &&
        div.scrollTop === 0
      ) {
        this.ScrollDown2 = true;
        this.ScrollUp2 = false;
      } else if (
        div.scrollHeight - div.scrollTop === div.clientHeight &&
        div.scrollTop !== 0
      ) {
        this.ScrollDown2 = false;
        this.ScrollUp2 = true;
      } else {
        this.ScrollDown2 = false;
        this.ScrollUp2 = false;
      }
    },
    managescroll() {
      let div = document.querySelector(".onscroll");
      if (
        div.scrollHeight - div.scrollTop !== div.clientHeight &&
        div.scrollTop !== 0
      ) {
        this.ScrollDown = true;
        this.ScrollUp = true;
      } else if (
        div.scrollHeight - div.scrollTop !== div.clientHeight &&
        div.scrollTop === 0
      ) {
        this.ScrollDown = true;
        this.ScrollUp = false;
      } else if (
        div.scrollHeight - div.scrollTop === div.clientHeight &&
        div.scrollTop !== 0
      ) {
        this.ScrollDown = false;
        this.ScrollUp = true;
      } else {
        this.ScrollDown = false;
        this.ScrollUp = false;
      }
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    // Manage Arrow for moving the scroll bar
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async goDown() {
      for (var i = 0; i < 40; i++) {
        await this.sleep(5);
        document.querySelector(".onscroll").scrollTop =
          document.querySelector(".onscroll").scrollTop + 1;
      }
    },
    async goUp() {
      for (var i = 0; i < 40; i++) {
        await this.sleep(5);
        document.querySelector(".onscroll").scrollTop =
          document.querySelector(".onscroll").scrollTop - 1;
      }
    },
    async goDown2() {
      for (var i = 0; i < 40; i++) {
        await this.sleep(5);
        document.querySelector(".onscroll2").scrollTop =
          document.querySelector(".onscroll2").scrollTop + 1;
      }
    },
    async goUp2() {
      for (var i = 0; i < 40; i++) {
        await this.sleep(5);
        document.querySelector(".onscroll2").scrollTop =
          document.querySelector(".onscroll2").scrollTop - 1;
      }
    },
    OpenChatUser() {
      var url = "#/chat/singleConv/" + this.userSelected;
      window.open(url, this.userSelected, "width=1200, height=750");
    },
    openModalAuthorization()
    {
      this._authorizedIPs = this.authorizedIPs;
      this._unauthorizedIPs = this.unauthorizedIPs;
      this._authorizedCountries = this.authorizedCountries;
      this._unauthorizedCountries = this.unauthorizedCountries;
      this._whitelistedWebsite = this.whitelistedWebsite;
      this._blacklistedWebsite = this.blacklistedWebsite;
      this.authorizedStreamTmp = this.authorizedStream;
      this.authorizedVPNsTmp = this.authorizedVPNs;
      this._authorizedVPNsList = this.authorizedVPNsList;
      this.ICEConfigTmp = this.ICEConfig;
      this.authorizedIPsTagsTmp = this.authorizedIPs.map(x => {return {key: x, value: x}});
      this.unauthorizedIPsTagsTmp = this.unauthorizedIPs.map(x => {return {key: x, value: x}});
      this.authorizedCountriesTagsTmp = this.authorizedCountries.map(x => {return {key: x, value: x}});
      this.unauthorizedCountriesTagsTmp = this.unauthorizedCountries.map(x => {return {key: x, value: x}});
      this.whitelistedWebsiteTagsTmp = this.whitelistedWebsite.map(x => {return {key: x, value: x}});
      this.blacklistedWebsiteTagsTmp = this.blacklistedWebsite.map(x => {return {key: x, value: x}});
      this.authorizedVPNsTagsTmp = this.authorizedVPNsList.map(x => {return {key: x, value: x}});
      this.customIceTmp = JSON.parse(JSON.stringify(this.customIce));
      this.isAuthorizedIPsTmp = this.isAuthorizedIPs;
      this.isAuthorizedCountriesTmp = this.isAuthorizedCountries;
      this.isAuthorizedWebsitesTmp = this.isAuthorizedWebsitesTmp;
    },
    updateAuthorization()
    {

      this.updateAuthorizedIPs();
      this.updateUnauthorizedIPs();
      this.updateAuthorizedCountries();
      this.updateUnauthorizedCountries();
      this.updateWhitelistedWebsites();
      this.updateBlacklistedWebsites();
      this.updateAuthorizedVPNsList();
      var result = this.customIceTmp.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })
      
      if(this.ICEConfigTmp === "QUANTEEC" || this.ICEConfigTmp === "local")
      {
        result = [];
      }

      var dataToSend = {
        authorizedIPs : this._authorizedIPs,
        unauthorizedIPs : this._unauthorizedIPs,
        authorizedCountries : this._authorizedCountries,
        unauthorizedCountries : this._unauthorizedCountries,
        whitelistedWebsite : this._whitelistedWebsite,
        blacklistedWebsite : this._blacklistedWebsite,
        authorizedVPNs : this.authorizedVPNsTmp,
        authorizedStream : this.authorizedStreamTmp,
        authorizedVPNsList : this._authorizedVPNsList,
        ICEConfig : this.ICEConfigTmp,
        customIce: result,
        isAuthorizedIPs:this.isAuthorizedIPsTmp,
        isAuthorizedCountries:this.isAuthorizedCountriesTmp,
        isAuthorizedWebsites:this.isAuthorizedWebsitesTmp,
      }

      console.log(dataToSend)

      

      pluginParamsService.updateDefaultParametersForClient(dataToSend, this.clientView ,this.$auth.token()).then(() => {
          
          
          this.authorizedIPs = this._authorizedIPs;
          this.unauthorizedIPs = this._unauthorizedIPs;
          this.authorizedCountries = this._authorizedCountries;
          this.unauthorizedCountries = this._unauthorizedCountries;
          this.whitelistedWebsite = this._whitelistedWebsite;
          this.blacklistedWebsite = this._blacklistedWebsite;
          this.authorizedVPNs = this.authorizedVPNsTmp;
          this.authorizedStream = this.authorizedStreamTmp;
          this.authorizedVPNsList = this._authorizedVPNsList;
          this.ICEConfig = this.ICEConfigTmp;
          this.customIce = result;
          this.isAuthorizedIPs = this.isAuthorizedIPsTmp;
          this.isAuthorizedCountries = this.isAuthorizedCountriesTmp;
          this.isAuthorizedWebsites = this.isAuthorizedWebsitesTmp;

          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })

    },
    resetModalAuthorization()
    {
      this._authorizedIPs = []
      this._unauthorizedIPs = []
      this._authorizedCountries = []
      this._unauthorizedCountries = []
      this._whitelistedWebsite = []
      this._blacklistedWebsite = []
      this.isAuthorizedIPsTmp = "IPAuthorized";
      this.isAuthorizedCountriesTmp = "countriesAuthorized"
      this.isAuthorizedWebsitesTmp = "websitesAuthorized"
      this.authorizedVPNsTmp = false;
      this.authorizedStreamTmp = false;
      this._authorizedVPNsList = []
      this.ICEConfigTmp = "QUANTEEC"
      this.modifyAuthorizedIPs = false;
      this.modifyUnauthorizedIPs = false;
      this.modifyAuthorizedCountries = false;
      this.modifyUnauthorizedCountries = false;
      this.modifyWhitelistedWebsites = false;
      this.modifyBlacklistedWebsites = false;
      this.modifyAuthorizedVPNs = false;
      this.customIceTmp = [];
    },

    updateAuthorizedIPs()
    {
      this._authorizedIPs = this.authorizedIPsTagsTmp.map(x => x.value);
      this.modifyAuthorizedIPs = false;
    },
    cancelAuthorizedIPs()
    {
      this.authorizedIPsTags = this.authorizedIPs.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedIPs = false;
    },
    updateUnauthorizedIPs()
    {
      this._unauthorizedIPs = this.unauthorizedIPsTagsTmp.map(x => x.value);
      this.modifyUnauthorizedIPs = false;
    },
    cancelUnauthorizedIPs()
    {
      this.unauthorizedIPsTags = this.unauthorizedIPs.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedIPs = false;
    },
    updateAuthorizedCountries()
    {
      this._authorizedCountries = this.authorizedCountriesTagsTmp.map(x => x.value);
      this.modifyAuthorizedCountries = false;
    },
    cancelAuthorizedCountries()
    {
      this.authorizedCountriesTagsTmp = this.authorizedCountries.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedCountries = false;
    },
    updateUnauthorizedCountries()
    {
      this._unauthorizedCountries = this.unauthorizedCountriesTagsTmp.map(x => x.value);
      this.modifyUnauthorizedCountries = false;
    },
    cancelUnauthorizedCountries()
    {
      this.unauthorizedCountriesTagsTmp = this.unauthorizedCountries.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedCountries = false;
    },
    updateWhitelistedWebsites(){
      this._whitelistedWebsite = this.whitelistedWebsiteTagsTmp.map(x=>x.value);
      this.modifyWhitelistedWebsites = false;
    },
    cancelWhitelistedWebsites(){
      this.whitelistedWebsiteTagsTmp = this._whitelistedWebsite.map(x => {return {key: x, value: x}});
      this.modifyWhitelistedWebsites = false;
    },

    updateBlacklistedWebsites(){
      this._blacklistedWebsite = this.blacklistedWebsiteTagsTmp.map(x=>x.value);
      this.modifyBlacklistedWebsites = false;
    },
    cancelBlacklistedWebsites(){
      this.blacklistedWebsiteTagsTmp = this._blacklistedWebsite.map(x => {return {key: x, value: x}});
      this.modifyBlacklistedWebsites = false;
    },

    updateAuthorizedVPNsList(){
      this._authorizedVPNsList = this.authorizedVPNsTagsTmp.map(x=>x.value);
      this.modifyAuthorizedVPNs = false;
    },
    cancelAuthorizedVPNsList(){
      this.authorizedVPNsTagsTmp = this._authorizedVPNsList.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedVPNs = false;
    },
    addSTUN(){
      this.customIceTmp.push({_id: uuidv4(), urls: ['']});
    },

    addTURN(){
      this.customIceTmp.push({_id: uuidv4(), urls: [''], username: '', credential: '', _showCredential: 'password'});
    },
    addUrl(ice) {
      ice.urls.push('');
    },
    removeUrl(ice, idx) {
      ice.urls.splice(idx, 1);
    },
    removeICE(indexIce) {
      this.customIceTmp.splice(indexIce, 1);
    },
  },
};
</script>
<style scoped lang="scss">
.mysidebar {
  display: block;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
  width: 200px;
  max-width: 200px;
}
.pdfstyle {
  color: red;
}
.fa-download:hover {
  color: white;
}
.item {
  border-bottom: #a9a9a9 2px solid;
  padding-top: 1%;
}
.item:hover {
  border-bottom: #a9a9a9 2px solid;
  padding-top: 1%;
  background-color: #e6e6e6;
}
.text {
  display: flex;
}
.overflow {
  height: 150px;
  overflow: auto;
  border: #a9a9a9 2px solid;
  border-radius: 5px;
}
.overflow2 {
  height: 150px;
  overflow: auto;
  border: #a9a9a9 2px solid;
  border-top: none;
}
.overflow3 {
  height: 150px;
  overflow: auto;
  border: #a9a9a9 2px solid;
  border-bottom: none;
}
.overflow4 {
  height: 150px;
  overflow: auto;
  border: #a9a9a9 2px solid;
  border-top: none;
  border-bottom: none;
}
.bottom {
  border: #a9a9a9 2px solid;
  border-radius: 5px;
  border-top: none;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.bottom:hover {
  border: #a9a9a9 2px solid;
  border-radius: 5px;
  border-top: none;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  background-color: #e6e6e6;
  cursor: pointer;
}
.up {
  border: #a9a9a9 2px solid;
  border-radius: 5px;
  border-bottom: none;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.up:hover {
  border: #a9a9a9 2px solid;
  border-radius: 5px;
  border-bottom: none;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: #e6e6e6;
  cursor: pointer;
}
</style>